import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../styles/Button.module.css";
var Button = function (_a) {
    var onClick = _a.onClick, children = _a.children, disabled = _a.disabled, type = _a.type, isFlatBottom = _a.isFlatBottom, isSecondary = _a.isSecondary, ariaLabel = _a.ariaLabel;
    var className = styles.button;
    if (isFlatBottom) {
        className += " ".concat(styles.flatBottom);
    }
    if (isSecondary) {
        className += " ".concat(styles.secondary);
    }
    return (_jsx("button", { type: type, disabled: disabled, className: className, onClick: onClick, style: { pointerEvents: "auto" }, "aria-label": ariaLabel, children: children }));
};
export default Button;
